import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const DURATION = 17 * 60 + 34; // 00:17:34

function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(DURATION);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? DURATION : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'Hours'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Sec'
  }];
  return <div className="w-full" data-id="element-71" data-mp="34qrwoj5ego77">
      <p className="mb-3 flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-white/60 sm:text-xs" data-id="element-72" data-mp="34r0dun8k2fo7">
        <ClockIcon className="h-4 w-4 text-lime" data-id="element-73" data-mp="2zpkqupmthz36" />
        This price expires in
      </p>
      <div className="flex items-center justify-center gap-2" role="timer" aria-live="off" aria-label={`Offer expires in ${pad(hours)} hours ${pad(minutes)} minutes ${pad(seconds)} seconds`} data-id="element-74" data-mp="1bzdk2csu45xi">
        {units.map(unit => <div key={unit.label} className="min-w-[68px] rounded-2xl border border-lime/30 bg-black px-3 py-2 text-center sm:min-w-[80px]" data-id="element-75" data-mp="170slsix57wbp">
            <span className="block font-display text-2xl leading-none text-lime sm:text-3xl" data-id="element-76" data-mp="1zpzu29meg0a5">
              {unit.value}
            </span>
            <span className="mt-1 block text-[10px] font-bold uppercase tracking-wider text-white/45" data-id="element-77" data-mp="1l0ljwzb01etp">
              {unit.label}
            </span>
          </div>)}
      </div>
    </div>;
}